import { useEffect } from 'react';
import { useStore } from 'zustand';
import { X } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { toastStore } from '../state/toasts';
import type { Toast } from '../state/toasts';

function ToastView({ toast }: { toast: Toast }) {
  const { t } = useTranslation();
  useEffect(() => {
    if (toast.timeout <= 0) return;
    const h = setTimeout(() => toastStore.getState().dismiss(toast.id), toast.timeout);
    return () => clearTimeout(h);
  }, [toast.id, toast.timeout]);
  return (
    <div className={`toast toast-${toast.kind}`} role={toast.kind === 'error' ? 'alert' : 'status'}>
      <span>{toast.message}</span>
      {toast.action && (
        <button
          type="button"
          className="btn btn-link"
          onClick={() => toastStore.getState().act(toast.id)}
        >
          {toast.action.label}
        </button>
      )}
      <button
        type="button"
        className="icon-btn"
        aria-label={t('action.dismiss')}
        onClick={() => toastStore.getState().dismiss(toast.id)}
      >
        <X size={14} />
      </button>
    </div>
  );
}

export function Toasts() {
  const toasts = useStore(toastStore, (s) => s.toasts);
  return (
    <div className="toasts" aria-live="polite">
      {toasts.map((t) => (
        <ToastView key={t.id} toast={t} />
      ))}
    </div>
  );
}
